// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".price[data-v-6a7232ca]{font-family:\"Montserrat\",sans-serif;font-weight:300;font-size:2rem}.price small[data-v-6a7232ca]{text-decoration:line-through!important;color:red}h1[data-v-6a7232ca]{margin:0}h1 small[data-v-6a7232ca]{color:red}.description ul[data-v-6a7232ca]{padding:0!important}@media (max-width:500px){.product-detail .price[data-v-6a7232ca],.product-detail h1[data-v-6a7232ca]{font-size:1.4rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
